import {
  StyledFooter,
  BotFooter,
  FooterLogo,
  PayWrapper,
  MasterCard,
  VisaCard,
  MenuWrapper,
  CompaniesWrapper,
  Polygon,
  MenuText,
  Moon,
} from "./styles/StyledFooter";
import {logoWhiteEngMinH, logoWhiteEngMinV, logoBlackEngMinH, logoBlackEngMinV, logoBlackEngH ,logoBlackEngV ,logoBlackRusH ,logoBlackRusV ,logoWhiteEngH ,logoWhiteEngV ,logoWhiteRusH ,logoWhiteRusV, logoWhiteEng  } from 'shared/assets';

import VisaCardSrc from "../../../../shared/assets/img/footer/visa.png";
import MasterCardSrc from "../../../../shared/assets/img/footer/mastercard.png";
import PolygonSrc from "../../../../shared/assets/img/footer/polygon.png";
import MoonSrc from "../../../../shared/assets/img/footer/moon.png";

import {ContainerMain } from "./styles/ContainerMain";
import {Stack} from "@mui/material";
import {useTranslation} from 'react-i18next';
import {useEffect, useState} from "react";

const Footer = () => {
  const { t, i18n } = useTranslation();
  const [curentLogo, setcurentLogo] = useState(logoWhiteEng);
  useEffect(() => {
    if(i18n.language == 'ru') {
      setcurentLogo(logoWhiteRusH)
    } else {
      setcurentLogo(logoWhiteEng)
    }
  }, [i18n.language]);

  return (
    <StyledFooter>
      <ContainerMain>
        <Stack sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '25px'
        }}>
          <Stack sx={{
            display: 'flex',
            flexDirection: {xs: 'column', md: 'row'},
            gap: '25px',
            fontSize: '16px'
          }}>
            <Stack sx={{
              display: 'flex',
              flexDirection:'column',
              gap: '25px'
            }}>
              <Stack sx={{
                display: 'flex',
                flexDirection: {xs: 'column', sm: 'row'},
                gap: '25px'
              }}>
                <Stack sx={{
                  display: 'flex',
                  flexDirection:'column',
                  gap: '25px'
                }}>
                  <FooterLogo src={curentLogo} alt="Footer Logo"  />
                  <MenuWrapper sx={{
                    flexDirection:'column'
                  }}>
                    <a href="https://web3wed.gitbook.io/web3wed">Whitepaper</a>
                    <a href="https://linktr.ee/web3wed">LinkTree</a>
                    <a href="https://web3wed.gitbook.io/web3wed/help">Help</a>
                    <a href="https://web3wed.gitbook.io/web3wed/terms-of-use">Terms of use</a>
                  </MenuWrapper>
                </Stack>
                <Stack sx={{
                  display: 'flex',
                  flexDirection:'column',
                  gap: '25px'
                }}>
                  <MenuText>
                    {t('footer_description_1')} <a href='https://finance.yahoo.com/news/revolutionizing-marriage-web3wed-io-launches-202500022.html'>Yahoo</a>, <a href='https://www.einnews.com/pr_news/891962967/nowyoucanseelove-records-vows-on-valentine-s-day-with-silk-restaurant-in-bali'>EINnews</a> {t('footer_description_2')} <a href="https://w3wed.io">w3wed.io</a>, <a href="https://web3wed.io">web3wed.io</a>.
                  </MenuText>
                  <MenuWrapper sx={{
                    flexDirection:'column'
                  }}>
                    <a href="https://www.instagram.com/nowyoucanseelove?igsh=dGw5cm42bDc5eTR4&utm_source=website">Instagram</a>
                    <a href="https://www.youtube.com/@web3wedding">Youtube</a>
                    <a href="https://twitter.com/web3wedding">X</a>
                    <a href="https://discord.gg/yNCDvAr6Wp">Discord</a>
                    <a href="https://www.tiktok.com/@web3wed">Tiktok</a>
                  </MenuWrapper>
                </Stack>
              </Stack>
            </Stack>
            <Stack sx={{
              display: 'flex',
              flexDirection:'column',
              gap: '25px'
            }}>
              <CompaniesWrapper>
                <Stack>
                  <Polygon src={PolygonSrc} alt="Polygon Logo" />
                  <Stack sx={{color: '#000'}}>
                    {t('footer_polygon')}
                    <a href="https://polygonscan.com/token/0x2312556105E89F5f5EbCC7362f312a6453c8bD9e">Polygon contract</a>
                  </Stack>
                </Stack>
                <Stack>
                  <Moon src={MoonSrc} alt="MoonPay Logo" />
                  <Stack sx={{color: '#000'}}>
                    {t('footer_moonpay')}
                  </Stack>
                </Stack>
                <PayWrapper>
                  <VisaCard src={VisaCardSrc} alt="Visa Card Logo" />
                  <MasterCard src={MasterCardSrc} alt="Master Card Logo" />
                </PayWrapper>
              </CompaniesWrapper>
            </Stack>
          </Stack>
          <Stack>
            <BotFooter>
              <div>COPYRIGHT 2023-2026 W3B0DZ LLC. ALL RIGHTS RESERVED</div>
              <div>
                Shams Business Center, Sharjah Media City Free Zone, Al Messaned,
                Sharjah, UAE.
              </div>
            </BotFooter>
          </Stack>
        </Stack>
        {/*<TopFooter>
          <div>
            <MenuWrapper>
              <a href="https://web3wed.gitbook.io/web3wed">Whitepaper</a>
              <a href="https://linktr.ee/web3wed">LinkTree</a>
              <a href="https://web3wed.gitbook.io/web3wed/help">Help</a>
              <a href="https://web3wed.gitbook.io/web3wed/terms-of-use">Terms of use</a>
            </MenuWrapper>
          </div>
          <span>We accept</span>
        </TopFooter>
        <MidFooter>
          <FooterLogo src={FooterLogoSrc} alt="Footer Logo" />
          <CompaniesWrapper>
            <Cloudflare src={CloudSrc} alt="Cloudflare Logo" />
            <Polygon src={PolygonSrc} alt="Polygon Logo" />
            <Moon src={MoonSrc} alt="MoonPay Logo" />
          </CompaniesWrapper>
          <PayWrapper>
            <VisaCard src={VisaCardSrc} alt="Visa Card Logo" />
            <MasterCard src={MasterCardSrc} alt="Master Card Logo" />
          </PayWrapper>
        </MidFooter>*/}

      </ContainerMain>
    </StyledFooter>
  );
};

export default Footer;
